<nav class="navbar scrolled navbar-expand-lg" [dir]="lang == 'ar' ? 'rtl' : 'ltr'">
  <!-- Logo -->
  <a class="navbar-brand" [routerLink]="['/', lang, 'home']" [attr.href]="'/' + lang + '/home'">
    <img
      *ngIf="whiteLogoPath"
      class="logo"
      [ngClass]="{ 'white-logo': whiteLogoPath }"
      [src]="whiteLogoPath"
      alt="Company-logo"
    />
    <img
      *ngIf="logoPath"
      class="logo"
      [ngClass]="{ 'dark-logo': whiteLogoPath }"
      [src]="logoPath"
      alt="Company-logo"
    />
  </a>

  <!-- Mobile menu -->
  <div class="menu d-block d-md-none pointer menu-icon">
    <label class="menu-icon" for="toggle">&#9776;</label>
    <input hidden type="checkbox" id="toggle" />
    <div class="menu-content">
      <label class="d-block d-md-none close-icon" for="toggle">
        <i class="bi bi-x-circle fs-3"></i>
      </label>

      <!-- Mobile nav links -->
      <div *ngFor="let tab of tabs">
        <a
          class="nav-item w-100 nav-link p-0"
          [routerLink]="['/', lang, tab.route]"
          [attr.href]="'/' + lang + tab.route"
          routerLinkActive="active"
          (click)="closeMobileMenu()"
        >
          {{ tab.name | translate }}
        </a>
      </div>

      <!-- Mobile language dropdown (checkbox-driven, no JS) -->
      <li class="nav-item dropdown" *ngIf="selectedLanguage">
        <div class="lang-wrap">
          <input id="langToggleMobile" type="checkbox" hidden />
          <label class="btn lang-btn" for="langToggleMobile">
            {{ selectedLanguage.name }}
            <img [src]="selectedLanguage.flag" alt="{{ selectedLanguage.name }}" />
          </label>

          <ul class="dropdown-menu w-50 mx-auto">
            <li *ngFor="let language of languages">
              <a
                class="dropdown-item d-flex"
                [href]="getNewURL(language.value)"
              >
                <h6>{{ language.name }}</h6>
                <img [src]="language.flag" alt="{{ language.name }}" />
              </a>
            </li>
          </ul>
        </div>
      </li>
    </div>
  </div>

  <!-- Desktop menu -->
  <ul id="navbarNav" class="tabs d-none d-md-flex m-0 gap-4 p-0 align-items-center">
    <div *ngFor="let tab of tabs" class="position-relative nav-item-wrapper">
      <!-- Dropdown tabs -->
      <ng-container *ngIf="tab.children; else normalTab">
        <div class="nav-item dropdown w-100">
          <a
            class="nav-link p-0 d-flex justify-content-between align-items-center"
            href="#"
            (click)="toggleTab(tab)"
          >
            {{ tab.name | translate }}
          </a>
          <div class="dropdown-menu w-100" *ngIf="openedTab === tab">
            <a
              *ngFor="let child of tab.children"
              class="dropdown-item"
              [routerLink]="['/', lang, child.route]"
              [attr.href]="'/' + lang + child.route + (child.id ? ('#' + child.id) : '')"
              [fragment]="child.id"
              (click)="openedTab = null"
            >
              {{ child.lable | translate }}
            </a>
          </div>
        </div>
      </ng-container>

      <!-- Normal tabs -->
      <ng-template #normalTab>
        <a
          class="nav-item w-100 nav-link p-0"
          [routerLink]="['/', lang, tab.route]"
          [attr.href]="'/' + lang + tab.route"
          routerLinkActive="active"
        >
          {{ tab.name | translate }}
        </a>
      </ng-template>
    </div>

    <!-- Desktop language dropdown (checkbox-driven, no JS) -->
    <li class="nav-item dropdown" *ngIf="selectedLanguage">
      <div class="lang-wrap">
        <input id="langToggleDesktop" type="checkbox" hidden />
        <label class="btn lang-btn" for="langToggleDesktop">
          {{ selectedLanguage.name }}
          <img [src]="selectedLanguage.flag" alt="{{ selectedLanguage.name }}" />
        </label>

        <ul class="dropdown-menu">
          <li *ngFor="let language of languages">
            <a
              class="dropdown-item d-flex"
              [href]="getNewURL(language.value)"
            >
              <h6 class="mb-0 me-0">{{ language.name }}</h6>
              <img [src]="language.flag" alt="{{ language.name }}" />
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</nav>
